import React, { useState, useEffect } from 'react';
import { FaEnvelope, FaPhoneAlt, FaMapMarkerAlt, FaTwitter, FaFacebookF, FaPinterestP, FaInstagram, FaPaperPlane, FaUserCircle, FaSearch } from 'react-icons/fa';
import './Navbar.css';

const navLinks = [
  { id: 'about', label: 'Home' },
  { id: 'research', label: 'Research' },
  { id: 'publications', label: 'Publications' },
  { id: 'students', label: 'Students' },
  { id: 'patents', label: 'Patents' },
  { id: 'contact', label: 'Contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [active, setActive] = useState('about');
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
      const sections = navLinks.map(l => document.getElementById(l.id));
      const current = sections.findIndex(s => {
        if (!s) return false;
        const rect = s.getBoundingClientRect();
        return rect.top <= 80 && rect.bottom > 80;
      });
      if (current !== -1) setActive(navLinks[current].id);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setMenuOpen(false);
  };

  return (
    <header className={`header ${scrolled ? 'header--scrolled' : ''}`}>
      <div className="topbar">
        <div className="topbar__inner">
          <div className="topbar__info">
            <div className="topbar__info-item">
              <FaEnvelope className="topbar__info-icon" />
              <span>professorjaganmohanreddychem@aknu.edu.in</span>
            </div>
            <div className="topbar__info-item">
              <FaPhoneAlt className="topbar__info-icon" />
              <span>+91-9347153270</span>
            </div>
            <div className="topbar__info-item">
              <FaMapMarkerAlt className="topbar__info-icon" />
              <span>AKNU, Rajahmundry, AP</span>
            </div>
          </div>
          
          <div className="topbar__socials">
            <a href="https://scholar.google.com/citations?user=MxYa8XQAAAAJ&hl=en" target="_blank" rel="noopener noreferrer" className="topbar__social-link" title="Google Scholar">G</a>
            <a href="https://orcid.org/0000-0001-9357-9610" target="_blank" rel="noopener noreferrer" className="topbar__social-link" title="ORCID">O</a>
            <a href="https://vidwan.inflibnet.ac.in/profile/653188" target="_blank" rel="noopener noreferrer" className="topbar__social-link" title="Vidwan">V</a>
          </div>
        </div>
      </div>

      <nav className="navbar">
        <div className="navbar__inner">
          <div className="navbar__brand" style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', color: '#fff', fontWeight: 'bold', fontSize: '1.25rem' }}>
            <div className="navbar__logo-icon" style={{ background: '#fff', color: 'var(--navy)', width: '32px', height: '32px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <FaSearch size={16} />
            </div>
            <span>Prof. JMR</span>
          </div>

          <button className="navbar__hamburger" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu">
            <span className={`hamburger-line ${menuOpen ? 'open' : ''}`}></span>
            <span className={`hamburger-line ${menuOpen ? 'open' : ''}`}></span>
            <span className={`hamburger-line ${menuOpen ? 'open' : ''}`}></span>
          </button>

          <ul className={`navbar__links ${menuOpen ? 'navbar__links--open' : ''}`}>
            {navLinks.map(link => (
              <li key={link.id}>
                <button
                  className={`navbar__link ${active === link.id ? 'navbar__link--active' : ''}`}
                  onClick={() => scrollTo(link.id)}
                >
                  {link.label}
                </button>
              </li>
            ))}
          </ul>
          
          <div className="navbar__actions">
             <button className="navbar__action-btn" onClick={() => scrollTo('research')}>
               <FaPaperPlane /> Join Research
             </button>
             <button className="navbar__action-btn" onClick={() => scrollTo('contact')}>
               <FaUserCircle /> Future Member
             </button>
          </div>
        </div>
      </nav>
    </header>
  );
}
